import { render, staticRenderFns } from "./ImgFullscreen.vue?vue&type=template&id=77ed0702&scoped=true&lang=pug&"
import script from "./ImgFullscreen.vue?vue&type=script&lang=ts&"
export * from "./ImgFullscreen.vue?vue&type=script&lang=ts&"
import style0 from "./ImgFullscreen.vue?vue&type=style&index=0&id=77ed0702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed0702",
  null
  
)

export default component.exports